import {
    WHATSAPP_LIST,
    WHATSAPP_LISTLOADING,

    WHATSAPP_VENDEDOR_LIST,
    WHATSAPP_VENDEDOR_LISTLOADING,

    WHATSAPP_CONTATOPARC_LIST,
    WHATSAPP_CONTATOPARC_LISTLOADING,

    WHATSAPP_CONTATOPARC_UPDATE,
    WHATSAPP_CONTATOPARC_UPDATELOADING,

    WHATSAPP_CONTATOPARC_INSERT,
    WHATSAPP_CONTATOPARC_INSERTLOADING,

    WHATSAPP_GET_VENDEDORES_RELATORIOLOADING,
    WHATSAPP_GET_VENDEDORES_RELATORIO,

    WHATSAPP_CLEAR_PARCEIROS,
    SET_VENDEDOR_FILTRO,

    // WHATSAPP_SALVA_PAGINATION,

} from '../actions/ActionsTypes';


const INITIAL_STATE = {
    vendedoresList: [],
    vendedoresLoader: false,

    parceirosList: [],
    parceirosLoader: false,

    contatosParcList: [],
    contatosParcLoader: false,

    contatosParcUpdate: [],
    contatosParcUpdateLoader: false,

    contatosParcInsert: [],
    contatosParcInsertLoader: false,

    vendedoresRelatorio: [],
    vendedoresRelatorioLoader: false,

    // atualPag: 1,
    // totalPag: 1,

    filtros: { vendedorSelect: null }

}


export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case WHATSAPP_VENDEDOR_LIST:
            return { ...state, vendedoresList: action.payload }

        case WHATSAPP_VENDEDOR_LISTLOADING:
            return { ...state, vendedoresLoader: action.payload }

        case WHATSAPP_LIST:
            const parceirosComQuantidades = action.payload.map(parceiro => ({
                ...parceiro,
                wpp_entregas_qtd: Number(parceiro.wpp_entregas_qtd) || 0,
                wpp_comercial_qtd: Number(parceiro.wpp_comercial_qtd) || 0,
                email_qtd: Number(parceiro.email_qtd) || 0
            }));
            return { ...state, parceirosList: parceirosComQuantidades, parceirosLoader: false }

        case WHATSAPP_LISTLOADING:
            return { ...state, parceirosLoader: action.payload }

        case WHATSAPP_CONTATOPARC_LIST:
            return { ...state, contatosParcList: action.payload }

        case WHATSAPP_CONTATOPARC_LISTLOADING:
            return { ...state, contatosParcLoader: action.payload }

        case WHATSAPP_CONTATOPARC_INSERT:
            return { ...state, contatosParcInsert: action.payload }

        case WHATSAPP_CONTATOPARC_INSERTLOADING:
            return { ...state, contatosParcInsertLoader: action.payload }

        case WHATSAPP_CONTATOPARC_UPDATE:
            return { ...state, contatosParcUpdate: action.payload }

        case WHATSAPP_CONTATOPARC_UPDATELOADING:
            //return { ...state, contatosParcUpdateLoader: action.payload }
            return {
                ...state,
                contatosParcUpdate: state.contatosParcUpdate.map(c => (
                    c.codcontato === action.payload.codcontato
                        && c.numnota === action.payload.numnota ? { ...c, ...action.payload } : c))
            }

        case WHATSAPP_GET_VENDEDORES_RELATORIO:
            return { ...state, vendedoresRelatorio: action.payload }

        case WHATSAPP_GET_VENDEDORES_RELATORIOLOADING:
            return { ...state, vendedoresRelatorioLoader: action.payload }

        case WHATSAPP_CLEAR_PARCEIROS
            : return { ...state, parceirosList: [] }

        case SET_VENDEDOR_FILTRO:
            return {
                ...state,
                filtros: {
                    ...state.filtros,
                    vendedorSelect: action.payload
                }
            };

        //case de atualizacao de quantidades de contatos com flags específicos
        // case 'ATUALIZAR_QUANTIDADES_PARCEIRO_LOCAL':
        //     const { codparc, novasQuantidades } = action.payload;
        //     return {
        //         ...state,
        //         parceirosList: state.parceirosList.map(parc =>
        //             parc.codparc === action.payload.codparc
        //                 ? { ...parc, ...action.payload.novasQuantidades }
        //                 : parc
        //         )
        //     };
        case 'ATUALIZAR_QUANTIDADES_PARCEIRO_LOCAL':

            return {
                ...state,

                parceirosList: state.parceirosList.map(parceiro => {

                    if (parceiro.codparc !== action.payload.codparc) {
                        return parceiro;
                    }

                    return {
                        ...parceiro,

                        wpp_entregas_qtd:
                            parceiro.wpp_entregas_qtd +
                            (action.payload.novasQuantidades.wpp_entregas_qtd || 0),

                        wpp_comercial_qtd:
                            parceiro.wpp_comercial_qtd +
                            (action.payload.novasQuantidades.wpp_comercial_qtd || 0),

                        email_qtd:
                            parceiro.email_qtd +
                            (action.payload.novasQuantidades.email_qtd || 0)
                    };
                })
            };

        // case WHATSAPP_ATUALPAG:
        //     return { ...state, atualPag: action.payload }

        // case WHATSAPP_TOTALPAG:
        //     return { ...state, totalPag: action.payload }

        // case 'WHATSAPP_SALVA_PAGINATION':
        //     return {
        //         ...state,
        //         atualPag: action.payload.page,
        //         totalPag: action.payload.total
        //     };


        default:
            return state;
    }
}